import { ApiService } from '$lib/services/api';
import { AppService } from '$lib/services/app';
import {
	assignAdjust,
	assignFirebase,
	EventType,
	filterAndTransportForCorePages,
	appendRevenueEvent,
	processSubscribeEvent,
	processRevenueEvent,
	processLoginEvent,
	processSSAdjustSubscribeEvent,
	processSSAdjustUpgradeEvent,
	processSSAdjustPageLoadEvent,
	filterInAppEvent
} from './common';
import EventLogger from './event-logger';
import { AdjustTransport } from './transport-adjust';
import { AdjustServerSideTransport } from './transport-adjust-server-side';
import { FirebaseTransport } from './transport-firebase';

/**
 * FirebaseTransformer is an object that maps event types to an array of transformer functions.
 * @typedef {{[key: string]: Array<Function>}} FirebaseTransformers
 */
const fireBaseTransformers = {
	[EventType.Subscribe]: [],
	[EventType.Upgrade]: [],
	[EventType.Auxiliary]: [],
	[EventType.PageLoad]: [filterInAppEvent, filterAndTransportForCorePages, assignFirebase],
	[EventType.LogIn]: []
};

/**
 * AdjustTransformers is an object that maps event types to an array of transformer functions.
 * @typedef	{{ [key: string]: Array<Function>; }} adjustTransformers
 */
const adjustTransformers = {
	[EventType.Subscribe]: [
		filterInAppEvent,
		processSubscribeEvent,
		appendRevenueEvent,
		assignAdjust
	],
	[EventType.Upgrade]: [filterInAppEvent, processRevenueEvent, assignAdjust],
	[EventType.Auxiliary]: [filterInAppEvent, assignAdjust],
	[EventType.PageLoad]: [filterInAppEvent, filterAndTransportForCorePages, assignAdjust],
	[EventType.LogIn]: [filterInAppEvent, processLoginEvent, assignAdjust]
};

/**
 * AdjustServerSideTransformers is an object that maps event types to an array of transformer functions.
 * @typedef	{{ [key: string]: Array<Function>; }} adjustServerSideTransformers
 */
const adjustServerSideTransformers = {
	[EventType.Subscribe]: [processSSAdjustSubscribeEvent],
	[EventType.Upgrade]: [processSSAdjustUpgradeEvent],
	[EventType.Auxiliary]: [],
	[EventType.PageLoad]: [processSSAdjustPageLoadEvent],
	[EventType.LogIn]: []
};

/**
 * AoflTransformers is an object that maps event types to an array of transformer functions.
 * @typedef	{{ [key: string]: Array<Function>; }} aoflTransformers
 */
// const aoflTransformers = {
//   [EventType.Subscribe]: [],
//   [EventType.Upgrade]: [],
//   [EventType.Auxiliary]: [],
//   [EventType.PageLoad]: [AoflTransport.processPageLoadEvent],
//   [EventType.AppLoad]: [AoflTransport.processAppLoadEvent],
//   [EventType.Click]: [AoflTransport.processClickEvent]
// };

const appService = new AppService();
const Logger = new EventLogger('EventLogger');

/*************************************************
 *************** TRANSPORTS **********************
 *************************************************/
const adjustTransport = new AdjustTransport('adjust', adjustTransformers, appService);
const adjustServerSideTransport = new AdjustServerSideTransport(
	'adjust-server-side',
	adjustServerSideTransformers,
	ApiService
);
const fireBaseTransport = new FirebaseTransport('firebase', fireBaseTransformers, appService);
// const aoflTransport = new AoflTransport('aofl', aoflTransformers, ApiService);

/**************************************************
 *************** Event Subscriptions **************
 *************************************************/
// Subscribe
Logger.addSubscriber(EventType.Subscribe, adjustTransport);
Logger.addSubscriber(EventType.Subscribe, adjustServerSideTransport);

// Upgrade
Logger.addSubscriber(EventType.Upgrade, adjustServerSideTransport);
// Logger.addSubscriber(EventType.Upgrade, adjustTransport);

// PageLoad
Logger.addSubscriber(EventType.PageLoad, adjustTransport);
Logger.addSubscriber(EventType.PageLoad, fireBaseTransport);
Logger.addSubscriber(EventType.PageLoad, adjustServerSideTransport);
// Logger.addSubscriber(EventType.PageLoad, aoflTransport);

// Login
// Logger.addSubscriber(EventType.LogIn, adjustTransport);

// AppLoad
// Logger.addSubscriber(EventType.AppLoad, aoflTransport);

// Click
// Logger.addSubscriber(EventType.Click, aoflTransport);

export default Logger;
